// extracted by mini-css-extract-plugin
export default {"pageContainer":"pmn_pageContainer__zyMSH","contentContainer":"pmn_contentContainer__YPP8R","menuButton":"pmn_menuButton__W9rhr","reviewButton":"pmn_reviewButton__hfnqA"};